/** billing: English + Arabic (Arabic is a draft for native review). */
const en = {
  "billing": "Billing",
  "billedMonthly": "Billed monthly",
  "billedYearly": "Billed yearly",
  "monthly": "Monthly",
  "yearly": "Yearly",
  "saveYearly": "Save {n}% with yearly billing",
  "perMonth": "a month",
  "perYear": "a year",
  "perPlayerPer": "per player {per}",
  "monthlyEquiv": "≈ {amount} per player a month",
  "everythingStandard": "Everything in Standard, plus:",
  "doubleStorage": "Twice the storage per player",
  "title": "Subscription",
  "managed": "Your {plan} plan for {seats} players was set up by Displaro without online payment. Choose a plan below to pay by card from now on.",
  "ownerOnly": "Only the organization owner can see and change billing.",
  "testMode": "Test mode: payments go to a test page and no real money is charged.",
  "pastDue": "Your last payment did not go through. Everything keeps working until {date} while we retry the card. Pay now to settle it.",
  "suspended": "Your subscription is paused because a payment did not go through: players keep showing content, but you can't add players, upload or invite until it is paid.",
  "ended": "Your subscription has ended. Restart it to add players, upload and invite again.",
  "restart": "Restart subscription",
  "payNow": "Pay now",
  "onTrial": "Free trial until {date}. Choose a plan to keep going after it.",
  "players": "Players",
  "playersUsed": "{used} in use of {seats}",
  "period": "Current month",
  "nextCharge": "Next charge",
  "nextChargeText": "{amount} on {date}",
  "includesCarry": "Includes {amount} for changes made this month.",
  "card": "Card",
  "noCard": "No card saved",
  "contact": "Billing contact",
  "edit": "Edit",
  "pending": "From {date}: {plan} plan, {seats} players.",
  "endsOn": "The subscription ends on {date}.",
  "keep": "Keep it",
  "changeTitle": "Change plan or players",
  "chooseTitle": "Choose a plan",
  "plan": "Plan",
  "fewer": "Fewer players",
  "more": "More players",
  "inUseHint": "1 player in use | {n} players in use",
  "contactName": "Billing name",
  "contactEmail": "Billing email",
  "contactPhone": "Phone (with country code)",
  "samePlan": "This is your current plan. Change the plan or the number of players to see the price.",
  "pricing": "Working out the price…",
  "dueToday": "Due today: {amount}",
  "deferred": "{amount} will be added to your next bill — nothing to pay today.",
  "nothingToday": "Nothing to pay today.",
  "fromDate": "Then {amount} {per} from {date}.",
  "fromDateLater": "From {date}: {plan}, {seats} players — {amount} {per}.",
  "fairHint": "Adding players or upgrading costs only the time left in this period. Fewer players, a lower plan or monthly billing start at the next renewal, so nothing you paid for is lost. Switching to yearly starts the year today and credits what's left of this month.",
  "choose": "Choose a plan",
  "payNowBtn": "Pay {amount}",
  "applyBtn": "Apply now",
  "scheduleBtn": "Schedule for next month",
  "working": "Working…",
  "changeSaved": "Subscription updated.",
  "cancelQ": "Cancel the subscription? It stays active until {date} and won't renew.",
  "cancelBtn": "Cancel subscription",
  "canceled": "Your subscription will end on {date}.",
  "kept": "Your subscription will renew as usual.",
  "cancelLink": "Cancel subscription",
  "contactSaved": "Billing contact saved.",
  "cancel": "Cancel",
  "save": "Save",
  "invoices": "Invoices",
  "kind_subscribe": "Subscription",
  "kind_change": "Plan change",
  "kind_renewal": "Monthly renewal",
  "st_paid": "Paid",
  "st_open": "Waiting",
  "st_failed": "Failed",
  "st_void": "Voided",
  "invoiceTitle": "Invoice {n}",
  "issued": "Issued {date}",
  "paidOn": "paid {date}",
  "item": "Item",
  "qty": "Qty",
  "amount": "Amount",
  "total": "Total",
  "print": "Print",
  "returnTitle": "Payment",
  "checking": "Checking your payment…",
  "paidOk": "Payment received. Your subscription is updated.",
  "failedPay": "The payment did not go through: {reason}",
  "stillWaiting": "The payment is still being processed. This page will update by itself.",
  "backToBilling": "Back to Subscription",
  "testPayTitle": "Test payment",
  "testPayText": "This is the test gateway: no real money moves. Pay {amount}?",
  "testPay": "Pay",
  "testDecline": "Decline",
  "banner_past_due": "A payment did not go through.",
  "banner_suspended": "Your subscription is paused until a payment goes through.",
  "fixPayment": "Fix payment",
  "buyMore": "Add more players",
};

const ar: typeof en = {
  "billing": "الفوترة",
  "billedMonthly": "فوترة شهرية",
  "billedYearly": "فوترة سنوية",
  "monthly": "شهري",
  "yearly": "سنوي",
  "saveYearly": "وفّر {n}% مع الفوترة السنوية",
  "perMonth": "شهريًا",
  "perYear": "سنويًا",
  "perPlayerPer": "لكل مشغل {per}",
  "monthlyEquiv": "≈ {amount} لكل مشغل شهريًا",
  "everythingStandard": "كل ما في القياسية، بالإضافة إلى:",
  "doubleStorage": "ضعف مساحة التخزين لكل مشغل",
  "title": "الاشتراك",
  "managed": "أعدّت Displaro خطة {plan} لـ {seats} مشغلات دون دفع إلكتروني. اختر خطة أدناه للدفع بالبطاقة من الآن.",
  "ownerOnly": "مالك المؤسسة وحده يمكنه رؤية الفوترة وتغييرها.",
  "testMode": "وضع الاختبار: تذهب المدفوعات إلى صفحة اختبار ولا تُخصم أموال حقيقية.",
  "pastDue": "لم تنجح آخر عملية دفع. يستمر كل شيء بالعمل حتى {date} بينما نعيد محاولة البطاقة. ادفع الآن لتسويتها.",
  "suspended": "اشتراكك متوقف لأن عملية دفع لم تنجح: تستمر الشاشات بعرض المحتوى، لكن لا يمكنك إضافة مشغلات أو الرفع أو الدعوة حتى يتم الدفع.",
  "ended": "انتهى اشتراكك. أعد تشغيله لإضافة المشغلات والرفع والدعوة مجددًا.",
  "restart": "إعادة تشغيل الاشتراك",
  "payNow": "ادفع الآن",
  "onTrial": "تجربة مجانية حتى {date}. اختر خطة للاستمرار بعدها.",
  "players": "المشغلات",
  "playersUsed": "{used} مستخدمة من {seats}",
  "period": "الشهر الحالي",
  "nextCharge": "الخصم التالي",
  "nextChargeText": "{amount} في {date}",
  "includesCarry": "يشمل {amount} للتغييرات التي أُجريت هذا الشهر.",
  "card": "البطاقة",
  "noCard": "لا توجد بطاقة محفوظة",
  "contact": "جهة اتصال الفوترة",
  "edit": "تعديل",
  "pending": "اعتبارًا من {date}: خطة {plan}، {seats} مشغلات.",
  "endsOn": "ينتهي الاشتراك في {date}.",
  "keep": "الإبقاء عليه",
  "changeTitle": "تغيير الخطة أو عدد المشغلات",
  "chooseTitle": "اختر خطة",
  "plan": "الخطة",
  "fewer": "مشغلات أقل",
  "more": "مشغلات أكثر",
  "inUseHint": "مشغل واحد مستخدم | {n} مشغلات مستخدمة",
  "contactName": "اسم الفوترة",
  "contactEmail": "بريد الفوترة",
  "contactPhone": "الهاتف (مع رمز الدولة)",
  "samePlan": "هذه خطتك الحالية. غيّر الخطة أو عدد المشغلات لرؤية السعر.",
  "pricing": "جارٍ حساب السعر…",
  "dueToday": "المستحق اليوم: {amount}",
  "deferred": "سيُضاف {amount} إلى فاتورتك التالية — لا شيء للدفع اليوم.",
  "nothingToday": "لا شيء للدفع اليوم.",
  "fromDate": "ثم {amount} {per} اعتبارًا من {date}.",
  "fromDateLater": "اعتبارًا من {date}: {plan}، {seats} مشغلات — {amount} {per}.",
  "fairHint": "إضافة مشغلات أو الترقية تكلف الوقت المتبقي من الفترة فقط. التخفيض أو الفوترة الشهرية تبدأ عند التجديد التالي، فلا تخسر شيئًا دفعته. التحويل إلى السنوي يبدأ السنة اليوم ويخصم المتبقي من هذا الشهر.",
  "choose": "اختر خطة",
  "payNowBtn": "ادفع {amount}",
  "applyBtn": "تطبيق الآن",
  "scheduleBtn": "جدولة للشهر القادم",
  "working": "جارٍ العمل…",
  "changeSaved": "حُدّث الاشتراك.",
  "cancelQ": "إلغاء الاشتراك؟ يبقى فعالًا حتى {date} ولن يتجدد.",
  "cancelBtn": "إلغاء الاشتراك",
  "canceled": "سينتهي اشتراكك في {date}.",
  "kept": "سيتجدد اشتراكك كالمعتاد.",
  "cancelLink": "إلغاء الاشتراك",
  "contactSaved": "حُفظت جهة اتصال الفوترة.",
  "cancel": "إلغاء",
  "save": "حفظ",
  "invoices": "الفواتير",
  "kind_subscribe": "اشتراك",
  "kind_change": "تغيير الخطة",
  "kind_renewal": "تجديد شهري",
  "st_paid": "مدفوعة",
  "st_open": "قيد الانتظار",
  "st_failed": "فشلت",
  "st_void": "ملغاة",
  "invoiceTitle": "الفاتورة {n}",
  "issued": "صدرت في {date}",
  "paidOn": "دُفعت في {date}",
  "item": "البند",
  "qty": "الكمية",
  "amount": "المبلغ",
  "total": "الإجمالي",
  "print": "طباعة",
  "returnTitle": "الدفع",
  "checking": "جارٍ التحقق من الدفع…",
  "paidOk": "تم استلام الدفع. حُدّث اشتراكك.",
  "failedPay": "لم تنجح عملية الدفع: {reason}",
  "stillWaiting": "لا تزال عملية الدفع قيد المعالجة. ستتحدث هذه الصفحة تلقائيًا.",
  "backToBilling": "العودة إلى الاشتراك",
  "testPayTitle": "دفع تجريبي",
  "testPayText": "هذه بوابة الاختبار: لا تُنقل أموال حقيقية. دفع {amount}؟",
  "testPay": "ادفع",
  "testDecline": "رفض",
  "banner_past_due": "لم تنجح عملية دفع.",
  "banner_suspended": "اشتراكك متوقف حتى تنجح عملية دفع.",
  "fixPayment": "إصلاح الدفع",
  "buyMore": "إضافة مشغلات",
};

export default { en, ar };
